import { AxiosPromise, AxiosResponse } from 'axios';
import { apiService } from '@app/services/api.service';
import { IActiveFilter } from '@app/models';
import { manageLogsFilters } from './filters.service';

class LogsService {
    getLogs(top: number, continuationToken: string, filters?: IActiveFilter[]): AxiosPromise {
        let filterString: any = manageLogsFilters(filters);
        let apiQuery: string = '/api/directory/Auditing/Query?$take=' + top;

        if (filterString !== undefined && filterString !== '') {
            apiQuery = apiQuery + filterString;
        }

        if (continuationToken !== '' && continuationToken !== undefined) {
            apiQuery += `&token=${continuationToken}`
        }

        return apiService.get(apiQuery)
            .catch((error: AxiosResponse) => Promise.reject(error));
    }
}

export const logsService = new LogsService();